// src/utils/numeriStrumenti.js
// Lettura dei numeri scritti nei campi degli Strumenti tecnici (W442). Prima molti campi
// leggevano «-0,27» come 0 e «8,5» come 8 (parseFloat si ferma alla virgola) e «1.234,56»
// come 1,234: nel fotovoltaico il coefficiente di temperatura scritto con la virgola non
// correggeva la Voc a freddo. Regole, uguali per tutti gli strumenti:
//   • la virgola è il separatore decimale («8,5» → 8.5); il punto anche («8.5» → 8.5), come prima;
//   • con punto e virgola insieme, quello che viene per ultimo è il decimale
//     («1.234,56» → 1234.56; «1,234.56» → 1234.56);
//   • più punti (o più virgole) sono separatori delle migliaia («1.000.000» → 1000000);
//   • spazi, «€» e «%» si ignorano. Un testo non numerico dà NaN (come parseFloat).
// Un numero scritto con il punto dà esattamente lo stesso risultato di prima.
export function leggiNumero(valore) {
  if (typeof valore === "number") return valore;
  let t = String(valore ?? "").replace(/[\s€% ']/g, "");
  if (!t) return NaN;
  const punti = (t.match(/\./g) || []).length, virgole = (t.match(/,/g) || []).length;
  if (punti && virgole) {
    if (t.lastIndexOf(",") > t.lastIndexOf(".")) t = t.replace(/\./g, "").replace(",", ".");
    else t = t.replace(/,/g, "");
  } else if (virgole > 1) t = t.replace(/,/g, "");
  else if (virgole === 1) t = t.replace(",", ".");
  else if (punti > 1) t = t.replace(/\./g, "");
  return parseFloat(t);
}

/** Numero o valore di riserva se il campo è vuoto o non numerico. */
export const numeroO = (valore, riserva = 0) => { const n = leggiNumero(valore); return Number.isFinite(n) ? n : riserva; };

/** Formato italiano con al massimo «dec» decimali. */
export const formatoIt = (n, dec = 2) => (n === null || n === undefined || !Number.isFinite(n) ? "—" : n.toLocaleString("it-IT", { maximumFractionDigits: dec }));
